/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SellerOfRecordEnum } from './sellerOfRecordEnum';


export interface SubscriptionSpec { 
    /**
     * Paid Pilot configuration
     */
    paid_pilot_config?: { [key: string]: any; };
    seller?: SellerOfRecordEnum;
    seller_id?: string;
}
export namespace SubscriptionSpec {
}


